angular.module('bmsApp.crm.enquiry')
	.factory('EnquirySourceSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

			return {
				options: function (params) {
					return CRUDSvc.get('api/enquirySource/options', params);
				}
			};

		}
	]);
